<template>
  <svg width="34" height="32" viewBox="0 0 34 32">
    <g fill="#00F0FF" fill-rule="evenodd">
      <path
        d="M34 8.01c-3.564 2.68-7.077 5.322-10.639 8.003l10.637 7.992L23.368 32v-5.042c-3.311-.24-6.11-1.565-8.444-3.794 1.219-1.595 2.43-3.183 3.656-4.793 1.214 1.45 2.77 2.392 4.769 2.574v-9.85c-1.033.134-1.95.532-2.78 1.14-.936.686-1.637 1.583-2.241 2.562-1.14 1.837-2.237 3.7-3.587 5.395-2.343 2.942-5.197 5.149-8.868 6.17-1.776.494-4.01.733-5.873.626v-5.984h.81c1.266-.007 2.514-.146 3.728-.534 1.726-.549 3.17-1.538 4.424-2.835 1.427-1.48 2.492-3.223 3.567-4.955.743-1.197 1.479-2.395 2.432-3.444 2.215-2.442 4.93-3.881 8.23-4.17.041-.002.083-.014.158-.03V0C26.928 2.689 30.44 5.333 34 8.009"
      />
      <path
        d="M0 11.002V5.005c.582 0 1.156-.014 1.73.005 1.563.052 3.106.225 4.606.704 1.868.598 3.423 1.673 4.784 3.047.28.284.556.576.813.88.06.071.09.25.045.318-1.046 1.604-2.102 3.198-3.158 4.791-.047.072-.11.134-.204.25C6.469 12.136 3.657 10.671 0 11.002"
      />
    </g>
  </svg>
</template>
<script>
export default {
  name: 'DoubleArrow'
};
</script>

<style></style>
